<mat-form-field appearance="fill" class="carrier-select">
    <mat-label>{{'carrier' | translate: ['tmc-yard.entity.transport.masterdata.carrier',
        translationService.language]}}</mat-label>
    <input matInput name="carrier" [formControl]="formControl" matInput
        [matAutocomplete]="autoCarriers" [required]="required" *ngIf="!disableAutoComplete">
    <input matInput name="carrier" [formControl]="formControl" matInput
        [required]="required" *ngIf="disableAutoComplete">
    <mat-autocomplete autoActiveFirstOption #autoCarriers="matAutocomplete">
        <ng-container>
            <mat-option *ngFor="let carrier of filteredCarriers" [value]="carrier">
                <span>{{carrier}}</span>
            </mat-option>
        </ng-container>
    </mat-autocomplete>
</mat-form-field>